'use strict';
module.exports = function sortNodesByLeftPosition(nodes) {
	if (!nodes || !nodes.length) {
		return nodes;
	}
	return [].concat(nodes).sort((a, b) => a.x - b.x);
};
